import { isPhase1MenuKey } from '@/config/menus';

export function isTenantMenuAllowed(
  menuKey: string | undefined,
  options: { skipTenantMenuCheck: boolean; canAccessMenu: (key: string) => boolean },
): boolean {
  if (!menuKey || options.skipTenantMenuCheck) return true;
  return isPhase1MenuKey(menuKey) && options.canAccessMenu(menuKey);
}
